import { render, staticRenderFns } from "./freightLook.vue?vue&type=template&id=69a2b60c&scoped=true&"
import script from "./freightLook.vue?vue&type=script&lang=ts&"
export * from "./freightLook.vue?vue&type=script&lang=ts&"
import style0 from "./freightLook.vue?vue&type=style&index=0&id=69a2b60c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a2b60c",
  null
  
)

export default component.exports